var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m54.54 32.65 11.12.6c2.43.13 3.44 3.18 1.57 4.74l-8.56 7.12 2.86 10.76c.63 2.36-1.96 4.26-4.02 2.96l-9.42-5.94-9.35 6.05c-2.05 1.32-4.65-.55-4.06-2.91l2.74-10.79-8.64-7.02c-1.89-1.54-.92-4.6 1.51-4.76l11.11-.73 4.01-10.39c.88-2.27 4.09-2.29 4.99-.03l4.13 10.34Z"
  })));
};
export default SvgStar;